import { BASE } from "../services/urls";

/////////////////
//Fichier pas encore utilisé
////////////////
export const API_GET_IMAGES = async ({ data }): Promise<ReturnType<() => any>> => {

    //const accessToken = localStorage.getItem("x-access-token");
    const options: any = {
        method: 'GET',
        headers: {
            'accept': 'application/json'
        },
        body: JSON.stringify({
            "id": data.id
        })
    };
    const response = await fetch(`${BASE}/images/`, options);
    const result = response.json();
    if(!response.ok) throw new Error(JSON.stringify(response.text()))
    return result
}

export const API_DISPLAY_IMAGE = async ({ data }): Promise<ReturnType<() => any>> => {

    const options: any = {
        method: 'GET',
        headers: {
            'accept': 'application/json',
        }
    };
    const response = await fetch(`${BASE}/images/${data.id}`, options);
    const result = response;
    if(!response.ok) throw new Error(JSON.stringify(response.text()))
    return result
}

export const API_GET_IMAGES_CAROUSEL = async ({ queryKey }): Promise<ReturnType<() => any>> => {

    const options: any = {
        method: 'GET',
        headers: {
            'accept': 'application/json',
        }
    };
    const response = await fetch(`${BASE}/images/?is_carousel=True`, options);
    const result = response.json();
    if(!response.ok) throw new Error(JSON.stringify(response.text()))
    return result
}

export const API_UPDATE_IMAGES = async (data): Promise<ReturnType<() => any>> => {

    const token = localStorage.getItem("x-imperso") || localStorage.getItem('x-access-token')
    //const { id, name, order, description } = data;

    const options: any = {
        method: 'PUT',
        headers: {
            'content-type': 'application/json',
            'accept': 'application/json',
            'lang': localStorage.getItem('i18nextLng'),
            "x-access-token": token,
        },
        body: JSON.stringify({
            "id": data.id,
            "name": data.name,
            "order": data.order,
            "description": data.description
        })
    };
    const response = await fetch(`${BASE}/images/image/update`, options);
    // console.log(response)
    if(!response.ok) throw new Error(JSON.stringify(response.text()))
    return response.json();

}

export const API_DELETE_IMAGES = async ({ queryKey }): Promise<ReturnType<() => any>> => {

    const token = localStorage.getItem("x-imperso") || localStorage.getItem('x-access-token')

    const { id } = queryKey[1];
    const options: any = {
        method: 'DELETE',
        headers: {
            'accept': 'application/json',
            'lang': localStorage.getItem('i18nextLng'),
            "x-access-token": token,
        }
    };
    const response = await fetch(`${BASE}/images/?id=${id}`, options)
    //const result = response.json();
    if(!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }
    return response.json();

}


export const API_CREATE_IMAGES = async (data): Promise<ReturnType<() => any>> => {
    const token = localStorage.getItem('x-access-token');
    const files=[
    data.file
    ]
    const payload={
            "order": data.order,
            "description": data.description,
            "is_carousel": data.is_carousel,
            "file": files
        }


    const options: any = {
        method: 'POST',
        headers: {
            "x-access-token": token,
        },
        body: payload
    };


    const response = await fetch(`${BASE}/images/image/upload`, options);
    if(!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to create image');
    }
    return response.json();
}


export const GetAllImages = async () => {
    const options: any = {
        method: 'GET',
        headers: {
            'accept': 'application/json',
            "x-access-token": localStorage.getItem('x-access-token'),
            'lang': localStorage.getItem('i18nextLng'),
        }
    };

    const response = await fetch(`${BASE}/images/`, options);
    const payload = await response.json().catch(() => null);

    if (!response.ok) {
        const errText = typeof payload === 'string' ? payload : (payload?.message || JSON.stringify(payload));
        throw new Error(errText || `HTTP ${response.status}`);
    }

    return payload.data;
}

export const GetImages = async ({ queryKey }) => {

    const { page, limit, sortBy } = queryKey[1];

    let sortParam = '';
    if (sortBy && sortBy.index !== undefined) {
        let field;
        if (sortBy.index === 0) field = 'name';
        else if (sortBy.index === 2) field = 'is_carousel';
        else if (sortBy.index === 3) field = 'uploaded_at';
        if (field) sortParam = `&sort_field=${field}&sort_direction=${sortBy.direction}`;
    }
    const options: any = {
        method: 'GET',
        headers: {
            'accept': 'application/json',
            "x-access-token": localStorage.getItem('x-access-token'),
            'lang': localStorage.getItem('i18nextLng'),
        }
    };

    const response = await fetch(`${BASE}/images/?limit=${limit}&page=${page}${sortParam}`, options);

    //if (!response.ok) throw new Error(JSON.stringify(response.text()));
    //console.log('before returning GetImages response');
    //return response.json()
    // parse JSON first
    const payload = await response.json().catch(() => null);

    if (!response.ok) {
        const errText = typeof payload === 'string' ? payload : (payload?.message || JSON.stringify(payload));
        throw new Error(errText || `HTTP ${response.status}`);
    }

    // Return the full payload to access count
    return payload;
}

export const DeleteImage = async (data: any) => {

    const options: any = {
        method: 'DELETE',
        headers: {
            'accept': 'application/json',
            'lang': localStorage.getItem('i18nextLng'),
            "x-access-token": localStorage.getItem('x-access-token'),
        },
    };

    const response = await fetch(`${BASE}/images/?id=${data.id}`, options);

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Delete failed');
    }

    // For 204 No Content, no body to parse
    return response;
}

// Ancienne recherche d'images au serveur
/* export const SearchImages = async ({ queryKey }) => {

    const { q, page, limit, sortBy } = queryKey[1];
    let sortParam = '';
    if (sortBy && sortBy.index !== undefined) {
        let field;
        if (sortBy.index === 0) field = 'name';
        else if (sortBy.index === 2) field = 'is_carousel';
        else if (sortBy.index === 3) field = 'uploaded_at';
        if (field) sortParam = `&sort_field=${field}&sort_direction=${sortBy.direction}`;
    }

    const options: any = {
        method: 'GET',
        headers: {
            'accept': 'application/json',
            'lang': localStorage.getItem('i18nextLng'),
            "x-access-token": localStorage.getItem("x-access-token")
        }
    }

    const response = await fetch(`${BASE}/images/search?param=${q}&limit=${limit||50}&page=${page||1}${sortParam}`, options);
    const payload = await response.json().catch(() => null);

    if (!response.ok) {
        const errText = typeof payload === 'string' ? payload : (payload?.message || JSON.stringify(payload));
        throw new Error(errText || `HTTP ${response.status}`);
    }

    return payload;
}
 */
